module.exports = __webpack_public_path__ + "static/media/reassign-vehicle.248df964.svg";